<template>
  <div class="t">
    <Navno v-if="identity != 1 && identity != 0"></Navno>
    <navStudent v-else-if="identity == 1"></navStudent>
    <Navteacher v-else></Navteacher>
    <img src="../../assets/Personback.png" alt=""
      style="width: .4167rem;height: .1458rem;position: relative; top: .183rem;left: 0.4604rem;"
      @click="$router.go(-1);">
    <div id="ctitle">{{ typelist[type - 1] }}</div>
    <!-- <div class="counseling">
      <div class="box" v-for="item in currentitems" :key="item.caid">
        <div class="inner">
          <div>
            <div class="title">{{ typelist[(type - 1)] }}</div>
            <div class="son">
              <img :src="'https://www.cdjjwang.com/' + item.image" alt="">
              <div class="txt">{{ 123 }}</div>
            </div>
          </div>

        </div>
      </div>
      <div style="width: 100vw;height: .6771rem;"></div>
    </div> -->
    <div class="counsel">
      <div class="box" v-for="item in currentitems" @click="open(item.url)">{{ item.title }}</div>
    </div>
    <div class="pagination">
      <!-- <div class="first" @click="pageindex = 1">首页</div> -->
      <el-pagination layout="prev, pager, next" :total="total" :page-size="9" :current-page="parseInt(pageindex)"
        :pager-count="7" @current-change="change" :key="pageindex">
      </el-pagination>
      <!-- <div class=" first" @click="pageindex = totalpages">尾页
      </div> -->
      <div class="txt">前往</div>
      <input type="text" v-model.lazy="pageindex">
      <div class="txt2">页</div>

    </div>
  </div>
</template>

<script>
import Navno from '../layout/nav-no.vue'
import Navteacher from '../layout/nav-teacher.vue'
import navStudent from '../layout/nav-student.vue'
export default {
  components: {
    Navno,
    Navteacher,
    navStudent,
  },
  data() {
    return {
      Authorization: '',
      identity: '',
      type: '',
      typelist: ['政策解读', '学君小课堂', '成长心理学'],
      total: 0,
      pageindex: 1,
      currentitems: [],
    }
  },
  created() {
    this.identity = localStorage.getItem('identity')
    this.type = this.$route.query.type
    this.$http.get('/Api/Web/Config/Articles', {
      params: {
        type: this.type,
        pageNumber: 1,
        pageSize: 9
      },
      headers: {
        'Authorization': localStorage.getItem('Authorization')
      }
    }).then(res => {
      this.total = res.data.data.total
      this.currentitems = Array.from(res.data.data.records)
      console.log(this.currentitems);
    }).catch(err => {
      console.log(err);
    })
  },
  methods: {
    change(index) {
      this.pageindex = index
    },
    open(url) {
      window.open(url)
    }
  },
  watch: {
    pageindex(n, o) {
      if (n !== o) {
        if (isNaN(parseInt(n))) {
          this.$message({
            message: '请输入数字',
            type: 'warning'
          });
          this.pageindex = o
          return false
        }
        if (n > Math.ceil(this.total / 9) || n < 1) {
          this.$message({
            message: '您输入的范围不对哦~~',
            type: 'warning'
          });
          this.pageindex = o
          return false
        }
        this.pageindex = n
        this.$http.get('/Api/Web/Config/Articles', {
          params: {
            pageNumber: n,
            pageSize: 9,
            type: this.type
          },
          headers: {
            'Authorization': this.Authorization
          }
        }).then(res => {
          console.log(res.data.data.records);
          this.currentitems = Array.from(res.data.data.records)
        })
      }
    },
  }
}
</script>

<style scoped>
.counsel {
  width: 1300px;
  height: auto;
  margin: 0 auto;
  padding-top: 50px;
}

.counsel .box {
  width: 1300px;
  height: 50px;
  line-height: 50px;
  font-size: 20px;
  border-bottom: solid 1px #ccc;
  padding-left: 20px;
  cursor: pointer;
}

#ctitle {
  font-size: 40px;
  margin-left: 250px;
}


.t /deep/ .el-pagination button {
  /* 上一页 */
  height: 35px;
  background: rgb(245, 245, 245);
  border-radius: 4px;
  color: rgb(0, 0, 0);
  font-family: Noto Sans SC;
  font-size: 15px;
  font-weight: 400;
  line-height: 35px;
  letter-spacing: 0px;
  text-align: center;
  padding: 0 !important;

}

/* .t /deep/ .el-pagination button,
  .t /deep/ .el-pagination li {
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  } */

.t .first,
.t /deep/ .pagination input {
  /* box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); */
  margin-top: 3px;
}

.t /deep/ .el-pagination .more {
  /* box-shadow: none !important; */
  /* color: rgb(1, 162, 153); */
  /* margin-top: 5px; */
  background: rgb(240, 242, 245);
  width: 32px;
  height: 35px;
  border-radius:
    2px;
  /* font-size: 30px; */
  padding-top: 3px;
}

.pagination {
  margin-top: 100px;
  display: flex;
  width: 100vw;
  height: 100px;
  justify-content: center;
  gap: 11px
}

.pagination .first {
  width: 46px;
  height: 35px;
  background: rgb(1, 162, 153);
  border-radius: 4px;
  /* 首页 */
  color: rgb(245, 245, 245);
  font-family: Noto Sans SC;
  font-size: 15px;
  font-weight: 400;
  line-height: 35px;
  letter-spacing: 0px;
  text-align: center;
  cursor: pointer;
}

.pagination .txt {
  /* 共 5 页 前往 */
  width: 40px;
  height: 35px;
  color: rgb(96, 98, 102);
  font-family: Noto Sans SC;
  font-size: 15px;
  font-weight: 400;
  line-height: 35px;
  letter-spacing: 0px;
  text-align: left;
  cursor: pointer;
  transform: translateX(10px);
}

.pagination input {
  /* 选页 */
  width: 60px;
  height: 35px;
  background: rgb(245, 245, 245);
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  text-align: center;
}

.pagination .txt2 {
  /* 页 */
  width: 15px;
  height: 35px;
  color: rgb(96, 98, 102);
  font-family: Noto Sans SC;
  font-size: 15px;
  font-weight: 400;
  line-height: 35px;
  letter-spacing: 0px;
  text-align: left;
  cursor: pointer;

}
</style>


// WEBPACK FOOTER //
// src/components/pages/Nocounseling.vue